import React from 'react';
import style from './css/services.module.css';

import certificate from '../../assets/middleseschool.webp';
import graduationcap from '../../assets/graduate.webp';

const Services = () => {
  return (
    <section className={style.servicesContainer}>
      <header className={style.servicesHeader}>
        <h2 className={style.servicesTitle}>Our Services</h2>
        <p className={style.servicesText}>
        At Aptech Lekki Centre, we offer a wide range of globally certified IT training programs designed to equip you with in-demand skills for today's digital economy. From Software Development, Data Analytics, AI/Machine Learning, Cyber Security and Networking to Graphic Design and Office Productivity, we provide expert-led courses that empower you to advance your career, switch industries, or start a new professional journey with confidence.
        </p>
      </header>

      <div className={style.servicesCards}>
        <div
          className={style.servicesCard}
          style={{ backgroundImage: `url(${certificate})` }}
        >
          <div className={style.overlay}>
            <h3 className={style.cardTitle}>International Certifications</h3>
            <p className={style.cardParagraph}>
              Students can earn an Advanced Diploma in Software Engineering (ADSE), a highly esteemed qualification recognized by employers and universities around the globe, through Aptech. With a rich history of over 30 years in IT training, Aptech is a trusted partner for career development. Aptech collaborates with NCC Education and esteemed institutions such as Middlesex, UCLAN, and Lincoln, providing students with the opportunity to attain globally recognized Bachelor's degrees.
            </p>
          </div>
        </div>

        <div
          className={style.servicesCard}
          style={{ backgroundImage: `url(${graduationcap})` }}
        >
          <div className={style.overlay}>
            <h3 className={style.cardTitle}>Access to 24/7 E-learning</h3>
            <p className={style.cardParagraph}>
              Online Varsity opens the door to exclusive e-learning opportunities, ensuring 24/7 access from any location, on any device, at your convenience. Discover interactive tools, invaluable resources, expert advice, and guidance tailored to enhance students' skills beyond the confines of the traditional classroom.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
